import { type PropsWithChildren } from 'react';
import { ScrollView, StyleSheet, type ScrollViewProps } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderModalScrollView = (props: Props) => {
  const { children, style, ...scrollViewProps } = props;

  // ─── Styles ──────────────────────────────────────────────────────────

  const scrollViewStyles = [styles.container, style];

  return (
    <ScrollView style={scrollViewStyles} {...scrollViewProps}>
      {children}
    </ScrollView>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<ScrollViewProps>;
